module.exports = __webpack_public_path__ + "media/assets/logoUsaid-ac845a17.png";